module.exports = __webpack_public_path__ + "static/bs-secure-pay-merchant-users-logos-7728e7e6eeebc1794567d5d4378c1f06.png";